/** 推广分享 invite / fid 解析 - 作者: zbq, 日期: 2026-07-21 */

const FID_KEY = 'wxfid';
const INVITE_KEY = 'wxinvite';
const COOKIE_INVITE = 'zq_wxinvite';
const COOKIE_FID = 'zq_wxfid';
/** 登录态跨 www / 主域：避免苹果微信 OAuth 回主域后从 www 打开丢 localStorage */
const COOKIE_UID = 'zq_uid';
const COOKIE_MEMBER_TENANT = 'zq_member_tenant';
const COOKIE_IS_MERCHANT = 'zq_is_merchant';
const COOKIE_ROLE = 'zq_role';
const COOKIE_MAX_AGE = 365 * 24 * 3600;

function isH5() {
  // #ifdef H5
  return typeof window !== 'undefined' && typeof document !== 'undefined';
  // #endif
  return false;
}

/**
 * 跨 www / 主域共享 cookie：按当前 host 推导根域（a.b.com → .b.com）。
 * IP / localhost 不加 Domain，避免浏览器拒写。
 */
function cookieDomain() {
  if (!isH5()) return '';
  const host = window.location.hostname || '';
  if (!host || host === 'localhost' || /^\d{1,3}(\.\d{1,3}){3}$/.test(host)) {
    return '';
  }
  const parts = host.split('.');
  if (parts.length < 2) return '';
  return `;domain=.${parts.slice(-2).join('.')}`;
}

function writeCookie(name, value) {
  if (!isH5() || value == null || value === '') return;
  try {
    const encoded = encodeURIComponent(String(value));
    document.cookie = `${name}=${encoded};path=/${cookieDomain()};max-age=${COOKIE_MAX_AGE};SameSite=Lax`;
  } catch (e) {
    // ignore
  }
}

function readCookie(name) {
  if (!isH5()) return '';
  try {
    const prefix = `${name}=`;
    const parts = String(document.cookie || '').split(';');
    for (let i = 0; i < parts.length; i++) {
      const part = parts[i].trim();
      if (part.indexOf(prefix) === 0) {
        return decodeURIComponent(part.slice(prefix.length));
      }
    }
  } catch (e) {
    // ignore
  }
  return '';
}

/** 从邀请码载荷解析内容店（T|{tenantId}|...），不验签；与 ?tenantId= 同级提示 */
function applyContentTenantFromInvite(token) {
  try {
    const dot = String(token).indexOf('.');
    if (dot <= 0) return;
    let b64 = token.slice(0, dot).replace(/-/g, '+').replace(/_/g, '/');
    while (b64.length % 4) b64 += '=';
    let payload = '';
    // #ifdef H5
    if (typeof atob === 'function') {
      payload = decodeURIComponent(
        Array.prototype.map
          .call(atob(b64), (c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join(''),
      );
    }
    // #endif
    if (!payload && typeof Buffer !== 'undefined') {
      payload = Buffer.from(b64, 'base64').toString('utf8');
    }
    if (!payload) return;
    const parts = payload.split('|');
    if (parts[0] === 'T' && parts[1] && /^[1-9]\d{0,18}$/.test(parts[1])) {
      uni.setStorageSync('tenant-id', parts[1]);
      // 店级码：立刻写入本店结算号（覆盖旧 wxfid），避免苹果微信首屏在 resolveInvite 前拉空
      const agentId = `t${parts[1]}_agent001`;
      uni.setStorageSync(FID_KEY, agentId);
      writeCookie(COOKIE_FID, agentId);
    }
  } catch (e) {
    // ignore
  }
}

/** 从当前推广码同步解析店级过滤 id（不依赖网络） */
export function getInviteShopFilterId() {
  restoreSharePromoFromCookie();
  const token = String(uni.getStorageSync(INVITE_KEY) || readCookie(COOKIE_INVITE) || '').trim();
  if (!token) return '';
  try {
    const dot = token.indexOf('.');
    if (dot <= 0) return '';
    let b64 = token.slice(0, dot).replace(/-/g, '+').replace(/_/g, '/');
    while (b64.length % 4) b64 += '=';
    let payload = '';
    // #ifdef H5
    if (typeof atob === 'function') {
      payload = decodeURIComponent(
        Array.prototype.map
          .call(atob(b64), (c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join(''),
      );
    }
    // #endif
    if (!payload) return '';
    const parts = payload.split('|');
    if (parts[0] === 'T' && parts[1] && /^[1-9]\d{0,18}$/.test(parts[1])) {
      return `t${parts[1]}_agent001`;
    }
  } catch (e) {
    // ignore
  }
  return '';
}

function clearShareFidStorage() {
  try {
    uni.removeStorageSync(FID_KEY);
  } catch (e) {
    // ignore
  }
  if (!isH5()) return;
  try {
    document.cookie = `${COOKIE_FID}=;path=/${cookieDomain()};max-age=0;SameSite=Lax`;
  } catch (e) {
    // ignore
  }
}

/** 保存签名推广码（优先于明文 fid） */
export function saveShareInvite(invite) {
  if (invite == null || invite === '' || invite === 'undefined' || invite === 'null') {
    return false;
  }
  const token = String(invite).trim();
  if (!token) return false;
  const prev = String(uni.getStorageSync(INVITE_KEY) || '').trim();
  uni.setStorageSync(INVITE_KEY, token);
  writeCookie(COOKIE_INVITE, token);
  // 新扫码必须丢掉上一家店的 wxfid，否则请求头 shareId 会盖过本次 invite
  if (prev !== token) {
    clearShareFidStorage();
  }
  applyContentTenantFromInvite(token);
  return true;
}

/** 保存推广商家 ID（旧版 ?fid=，仅兼容） */
export function saveShareFid(fid) {
  if (fid == null || fid === '' || fid === 'undefined' || fid === 'null') {
    return false;
  }
  const id = String(fid).trim();
  if (!id) return false;
  uni.setStorageSync(FID_KEY, id);
  writeCookie(COOKIE_FID, id);
  return true;
}

/** 从页面路由参数解析推广来源 */
export function parseFidFromQuery(query = {}) {
  const invite = query.invite;
  if (invite && saveShareInvite(invite)) {
    return true;
  }
  const fid = query.fid || query.shareId || query.merchantId;
  return saveShareFid(fid);
}

/** H5：从 URL 查询参数解析（含 hash 路由 ?invite= / #/?invite=） */
export function parseFidFromUrl() {
  // #ifdef H5
  if (typeof window === 'undefined') return false;
  try {
    const href = window.location.href;
    const url = new URL(href);
    let invite = url.searchParams.get('invite');
    let fid = url.searchParams.get('fid') || url.searchParams.get('shareId');

    // hash 模式：#/path?invite= 或 #/?invite=
    if (!invite && !fid && url.hash && url.hash.indexOf('?') >= 0) {
      const hashQuery = url.hash.slice(url.hash.indexOf('?') + 1);
      const hashParams = new URLSearchParams(hashQuery);
      invite = hashParams.get('invite');
      fid = hashParams.get('fid') || hashParams.get('shareId');
    }

    if (invite && saveShareInvite(invite)) {
      return true;
    }
    if (fid) return saveShareFid(fid);
  } catch (e) {
    // ignore
  }
  // #endif
  return false;
}

function clearCookie(name) {
  if (!isH5()) return;
  try {
    document.cookie = `${name}=;path=/${cookieDomain()};max-age=0;SameSite=Lax`;
  } catch (e) {
    // ignore
  }
}

/**
 * 登录后把 uid / 所属店 / 商家标记写入当前站点根域 cookie，
 * 解决苹果微信 www 与主域 localStorage 隔离导致「安卓有数、苹果空」。
 */
export function persistShopSessionToCookie() {
  const uid = uni.getStorageSync('id') || '';
  if (uid) writeCookie(COOKIE_UID, uid);
  else clearCookie(COOKIE_UID);

  const memberTenant = uni.getStorageSync('member-tenant-id') || '';
  if (memberTenant) writeCookie(COOKIE_MEMBER_TENANT, String(memberTenant));
  else clearCookie(COOKIE_MEMBER_TENANT);

  const isMerchant = uni.getStorageSync('zq_is_merchant');
  const merchantOn =
    isMerchant === true || isMerchant === 'true' || isMerchant === 1 || isMerchant === '1';
  if (merchantOn) writeCookie(COOKIE_IS_MERCHANT, '1');
  else clearCookie(COOKIE_IS_MERCHANT);

  const role = uni.getStorageSync('zq_role') || '';
  if (role) writeCookie(COOKIE_ROLE, role);
  else clearCookie(COOKIE_ROLE);
}

/** 启动时从 cookie 回填登录/店铺上下文（不覆盖已有非空 storage） */
export function restoreShopSessionFromCookie() {
  let restored = false;
  if (!uni.getStorageSync('id')) {
    const uid = readCookie(COOKIE_UID);
    if (uid) {
      uni.setStorageSync('id', uid);
      uni.setStorageSync('zq_token', uid);
      restored = true;
    }
  }
  if (!uni.getStorageSync('member-tenant-id')) {
    const tenant = readCookie(COOKIE_MEMBER_TENANT);
    if (tenant && Number(tenant) > 0) {
      uni.setStorageSync('member-tenant-id', String(tenant));
      restored = true;
    }
  }
  const flag = uni.getStorageSync('zq_is_merchant');
  const hasFlag =
    flag === true || flag === 'true' || flag === 1 || flag === '1' || flag === false || flag === 'false';
  if (!hasFlag) {
    const c = readCookie(COOKIE_IS_MERCHANT);
    if (c === '1') {
      uni.setStorageSync('zq_is_merchant', true);
      restored = true;
    }
  }
  if (!uni.getStorageSync('zq_role')) {
    const role = readCookie(COOKIE_ROLE);
    if (role) {
      uni.setStorageSync('zq_role', role);
      restored = true;
    }
  }
  return restored;
}

export function clearShopSessionCookies() {
  clearCookie(COOKIE_UID);
  clearCookie(COOKIE_MEMBER_TENANT);
  clearCookie(COOKIE_IS_MERCHANT);
  clearCookie(COOKIE_ROLE);
}

/**
 * 推广域→主站支付跳转：从 URL 回填 uid/openid（根域不同，cookie 无效）。
 * 与 parseFidFromUrl 配合；不覆盖已有非空 uid。
 */
export function restoreCrossDomainPaySessionFromUrl() {
  // #ifdef H5
  if (typeof window === 'undefined') return false;
  let restored = false;
  try {
    const url = new URL(window.location.href);
    const pick = (key) => {
      let v = url.searchParams.get(key);
      if (!v && url.hash && url.hash.indexOf('?') >= 0) {
        const hp = new URLSearchParams(url.hash.slice(url.hash.indexOf('?') + 1));
        v = hp.get(key);
      }
      return v ? String(v).trim() : '';
    };
    const uid = pick('zq_uid') || pick('uid');
    if (uid && !uni.getStorageSync('id')) {
      uni.setStorageSync('id', uid);
      uni.setStorageSync('zq_token', uid);
      restored = true;
    }
    const openid = pick('openid');
    if (openid) {
      if (!uni.getStorageSync('openid')) uni.setStorageSync('openid', openid);
      if (!uni.getStorageSync('openId')) uni.setStorageSync('openId', openid);
      if (!uni.getStorageSync('wx_openid')) uni.setStorageSync('wx_openid', openid);
      restored = true;
    }
    const tenantId = pick('tenantId');
    if (tenantId && !uni.getStorageSync('tenant-id')) {
      uni.setStorageSync('tenant-id', tenantId);
      restored = true;
    }
  } catch (e) {
    // ignore
  }
  return restored;
  // #endif
  return false;
}

/**
 * 微信 OAuth 回调前后调用：从 cookie 回填 localStorage，
 * 避免扫码与支付回调落在不同主机时丢失推广码。
 */
export function restoreSharePromoFromCookie() {
  let restored = false;
  const invite = readCookie(COOKIE_INVITE);
  if (invite) {
    uni.setStorageSync(INVITE_KEY, invite);
    restored = true;
  }
  const fid = readCookie(COOKIE_FID);
  if (fid) {
    uni.setStorageSync(FID_KEY, fid);
    restored = true;
  }
  return restored;
}

/** 跳转微信 OAuth 前：确保 cookie 已写入当前推广码 */
export function persistSharePromoForOAuth() {
  const invite = uni.getStorageSync(INVITE_KEY) || readCookie(COOKIE_INVITE) || '';
  if (invite) {
    saveShareInvite(invite);
  }
  const fid = uni.getStorageSync(FID_KEY) || readCookie(COOKIE_FID) || '';
  if (fid) {
    saveShareFid(fid);
  }
}

export function getShareInvite() {
  let invite = uni.getStorageSync(INVITE_KEY) || '';
  if (invite) return invite;
  invite = readCookie(COOKIE_INVITE);
  if (invite) {
    uni.setStorageSync(INVITE_KEY, invite);
    return invite;
  }
  return '';
}

export function getShareFid() {
  let fid = uni.getStorageSync(FID_KEY) || '';
  if (fid) return fid;
  fid = readCookie(COOKIE_FID);
  if (fid) {
    uni.setStorageSync(FID_KEY, fid);
    return fid;
  }
  return '';
}

/** 注册/登录/下单请求体附加推广字段：优先 invite，否则旧 fid */
export function appendPromoFields(payload = {}) {
  restoreSharePromoFromCookie();
  const invite = getShareInvite();
  if (invite) {
    payload.invite = invite;
    return payload;
  }
  const fid = getShareFid();
  if (fid) payload.fid = fid;
  return payload;
}

/** 是否已保存有效推广参数（本地缓存 / cookie） */
export function hasSharePromo() {
  restoreSharePromoFromCookie();
  return !!(getShareInvite() || getShareFid());
}
